export const modeOptions = [
	{ value: 'ltl', label: 'ltl' },
	{ value: 'volume', label: 'volume' },
	{ value: 'truckload', label: 'truckload' },
	{ value: 'ocean', label: 'ocean' },
	{ value: 'air', label: 'air' },
]
